import React from "react";
import { Layout } from "react-admin";
import CustomAppBar from "./TutiAppBar";

const CustomLayout = (props) => <Layout {...props} appBar={CustomAppBar} />;

export default CustomLayout;
